import AlertOutlineIcon from "mdi-react/AlertOutlineIcon";
import React from "react";

const WarningIcon = ({text = null}) => <span style={{display: 'flex', alignItems: 'center'}}>
    <AlertOutlineIcon style={{color: 'red', marginBottom: '3px', paddingRight: '3px'}} className="my-auto" size={18} /> {text && text}
</span>;

export default WarningIcon;
